import { DisplayTable } from '@policoders/ds';
import PageHeader from '@shared/components/page-header';

import { useProduct } from './product.hook';

export const ProductPage = () => {
  const { lines, tActions, tColumns, tHeaderButtons, handleEdit } = useProduct();

  return (
    <>
      <PageHeader title="Produtos" />
      <DisplayTable
        actions={tActions}
        columns={tColumns}
        headerButtons={tHeaderButtons}
        lines={lines}
        groupLinesBy={'measureUnit'}
        onLineClick={handleEdit}
      />
    </>
  );
};
